export const ALL_USER_FREE_TRIAL = 'ALL_USER_FREE_TRIAL';
export const ALL_USER_FREE_TRIAL_ORIGINAL = 'A';
export const ALL_USER_FREE_TRIAL_VARIATION = 'B';
export const REGISTRATION_HIDE_SOCIAL_SIGN_UPS = 'REGISTRATION_HIDE_SOCIAL_SIGN_UPS';
export const REGISTRATION_HIDE_SOCIAL_SIGN_UPS_ORIGINAL = 'A';
export const REGISTRATION_HIDE_SOCIAL_SIGN_UPS_VARIATION = 'B';
export const LIVE_LEARNING_ES_VIDEO_MODULE = 'LIVE_LEARNING_ES_VIDEO_MODULE';
export const LIVE_LEARNING_ES_VIDEO_MODULE_ORIGINAL = 'A';
export const LIVE_LEARNING_ES_VIDEO_MODULE_VARIATION = 'B';
const experiments = {
    [ALL_USER_FREE_TRIAL]: {
        experimentId: '19653920650',
        variations: {
            19574801875: ALL_USER_FREE_TRIAL_ORIGINAL,
            19584734574: ALL_USER_FREE_TRIAL_VARIATION
        }
    },
    [REGISTRATION_HIDE_SOCIAL_SIGN_UPS]: {
        experimentId: '20426483062',
        variations: {
            20453193300: REGISTRATION_HIDE_SOCIAL_SIGN_UPS_ORIGINAL,
            20422503636: REGISTRATION_HIDE_SOCIAL_SIGN_UPS_VARIATION
        }
    },
    [LIVE_LEARNING_ES_VIDEO_MODULE]: {
        experimentId: '20543132632',
        variations: {
            20526214063: LIVE_LEARNING_ES_VIDEO_MODULE_ORIGINAL,
            20539250040: LIVE_LEARNING_ES_VIDEO_MODULE_VARIATION
        }
    }
};
export default experiments;
